import { render, staticRenderFns } from "./policiesregulationsdetail.vue?vue&type=template&id=59cfc8e8&scoped=true&"
import script from "./policiesregulationsdetail.vue?vue&type=script&lang=js&"
export * from "./policiesregulationsdetail.vue?vue&type=script&lang=js&"
import style0 from "./policiesregulationsdetail.vue?vue&type=style&index=0&id=59cfc8e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cfc8e8",
  null
  
)

export default component.exports